import { createTeleSession, type Logger, type MediaProfile, type TeleSession } from '@shareview/tele-engine-core';
import { createLiveKitTransport } from '@shareview/tele-engine-transport-livekit';
import { createWebMediaAdapter } from '@shareview/tele-engine-web';

const logger: Logger = {
  log: (level, message, meta) => {
    const line = `[tele-poc] ${message}`;
    if (level === 'error') console.error(line, meta ?? '');
    else if (level === 'warn') console.warn(line, meta ?? '');
    else if (level === 'info') console.info(line, meta ?? '');
  },
};

/**
 * The page's one TeleSession, built from the packages only: LiveKit transport,
 * browser media adapter, and the profile from the query string. The session
 * outlives joins; `leave()` then `join()` again rejoins.
 */
export function createPocSession(profile: MediaProfile): TeleSession {
  const session = createTeleSession({
    transport: createLiveKitTransport({ logger }),
    media: createWebMediaAdapter({ logger }),
    profile,
    stallDetection: { intervalMs: 1000, thresholdMs: 5000 },
    logger,
  });
  // Exposed for debugging and automated checks.
  (window as { __teleSession?: TeleSession }).__teleSession = session;
  return session;
}
